import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "@shared/styles/colors.json";

Vue.use(Vuetify);

// "Dark Studio" palette - mirrors src/styles/colors.css. Vuetify paints its
// own components (inputs, menus, lists, chips) from this set; everything
// custom reads the CSS variables. Keep the two in sync.
export default new Vuetify({
  theme: {
    // Read dark mode setting from colors.json (dark-only product; the light
    // theme below is a fallback so nothing renders unstyled if it flips).
    dark: colors.darkMode !== undefined ? colors.darkMode : true,
    // Expose --v-<name>-base custom properties for CSS fallbacks.
    options: { customProperties: true },
    themes: {
      dark: {
        primary: "#a855f7",
        secondary: "#ec4899",
        accent: "#c084fc",
        error: "#f87171",
        warning: "#fbbf24",
        info: "#a855f7",
        success: "#34d399",
        background: "#0b0b10",
        surface: "#15151d",
        "card-bg": "#15151d",
        "card-bg-alt": "#1b1b25",
        "border-color": "#23232f",
        "text-primary": "#ececf1",
        "text-secondary": "#a1a1ae",
        "text-heading": "#ffffff",
        "input-bg": "#12121a"
      },
      light: {
        primary: colors.colorInfo || "#a855f7",
        secondary: colors.colorInfoBright || "#c084fc",
        accent: colors.colorInfoLight || "#d8b4fe",
        error: colors.colorError || "#f87171",
        info: colors.colorInfo || "#a855f7",
        success: colors.colorSuccess || "#34d399",
        warning: colors.colorWarning || "#fbbf24",
        background: colors.bgPrimary || "#ffffff",
        surface: colors.bgSecondary || "#f8f9fa"
      }
    }
  },
  icons: {
    iconfont: "mdi" // Ensure Material Design Icons are used
  }
});
